<template>
  <div>
    <b-row>
      <b-col
        v-for="item in telefonesuteis"
        :key="item.id"
        cols="12"
        md="4"
        class="d-flex"
      >
        <b-card
          :title="item.contato"
          class="w-100"
        >
          <b-row>
            <b-col align="left">
              <feather-icon
                icon="PhoneIcon"
              />
            </b-col>
            <b-col align="right">
              {{ item.telefone }}
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      pagination: { page: 1, size: 99999 },
    }
  },
  computed: {
    telefonesuteis() {
      return this.$store.state.telefonesuteis.telefonesuteis
    },
  },
  created() {
    this.$store.dispatch('telefonesuteis/fetchAll')
  },
  beforeCreate() {
    this.$store.dispatch('telefonesuteis/clear')
  },
}
</script>
